import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "./config";
import { ContentBlock } from "../types/courseBlocks";

export interface CourseModule {
  id?: string;
  courseSlug: string;
  chapterSlug: string;
  number: string;
  slug: string;
  title: string;
  published: boolean;
  order: number;
  blocks: ContentBlock[];
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

const courseModulesCollection = collection(db, "courseModules");

export const getAllCourseModules = async (): Promise<CourseModule[]> => {
  const snapshot = await getDocs(
    query(courseModulesCollection, orderBy("order", "asc"))
  );
  return snapshot.docs.map(
    (docSnap) => ({ id: docSnap.id, ...docSnap.data() } as CourseModule)
  );
};

export const createCourseModule = async (
  courseModule: Omit<CourseModule, "id" | "createdAt" | "updatedAt">
): Promise<string> => {
  const docRef = await addDoc(courseModulesCollection, {
    ...courseModule,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateCourseModule = async (
  id: string,
  courseModule: Partial<Omit<CourseModule, "id" | "createdAt" | "updatedAt">>
): Promise<void> => {
  await updateDoc(doc(db, "courseModules", id), {
    ...courseModule,
    updatedAt: serverTimestamp(),
  });
};

export const deleteCourseModule = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, "courseModules", id));
};

export const reorderCourseModules = async (
  orderedIds: string[]
): Promise<void> => {
  const batch = writeBatch(db);
  orderedIds.forEach((id, index) => {
    batch.update(doc(db, "courseModules", id), {
      order: index,
      updatedAt: serverTimestamp(),
    });
  });
  await batch.commit();
};
